export const NOTIFICATION = {
  SUPPLIER: {
    GROUP_TYPE: '1',
    DESCRIPTION: 'Proveedores',
  },
  REGION: {
    GROUP_TYPE: '2',
    DESCRIPTION: 'Region',
  },
  COUNTRY: {
    GROUP_TYPE: '3',
    DESCRIPTION: 'País',
  },
  TREASURY_GROUPS: {
    GROUP_TYPE: '4',
    DESCRIPTION: 'Grupos de  tesorería',
  },
  CRITICAL_SUPPLIER: {
    GROUP_TYPE: '5',
    DESCRIPTION: 'Proveedores Criticos'
  },
  ALL_SUPPLIER: {
    GROUP_TYPE: '6',
    DESCRIPTION: 'Todos los proveedores'
  },
};

export const SUPPLIER_TYPES = {
  LOCAL: 'Proveedor Local',
  EXTERNAL: 'Proveedor Extranjero'
};

export const EMPLOYEE = {
  EMPLOYEE: 'Empleado'
}

export const STORAGE = {
  TOKEN: 'token',
  LOGOUT: 'logout',
  USER_INFO: 'userInfo',
  get: key => {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
    // const value = localStorage.getItem(btoa(btoa(key)));
    // return value ? JSON.parse(atob(atob(value))) : null;
  },
  set: (key, value) => localStorage.setItem(key, JSON.stringify(value)),
  // set: (key, value) => localStorage.setItem(btoa(btoa(key)), btoa(btoa(JSON.stringify(value)))),
  clear: () => localStorage.clear(),
};

export const LOGIN_ENDPOINTS = {
  LOGIN: '/Authenticate/login',
  SIGN_UP: '/Authenticate/register',
  FORGOT_PASSWORD: '/Authenticate/passwordchange',
  CONFIRM_SIGN_UP: '/Authenticate/confirmregister',
  CHANGE_PASSWORD: '/Authenticate/confirmpassword',
  VALIDATE_MFA_CODE: '/Authenticate/validatemfa',
  NEW_MFA_CODE: '/Authenticate/newmfacode'
};

export const ROLES = {
  ADMIN: 'ADMINISTRADOR',
  AUDIT: 'AUDITORÍA',
  GENERIC: 'GENERICO',
  APAYABLE: 'CUENTAS A PAGAR',

};

export const SOURCETYPES = {
  MATERIAL_REQUIRES: 'MaterialRequiresCertificate',
  EXCLUDED_SUPPLIER: 'ExcludedSupplier',
  EXCLUDED_PURCHASE_ORDER: 'ExcludedPurchaseOrder',
  CERTIFICATE_REQUEST: 'CertificateRequest',
  ACTIVITY_LOGS: 'ActivityLogs'
}
